import { Icon } from 'gu-ui-kit'
import React from 'react'

export default () => {
  return {
    initial: {
      search: '',
      methods: [],
      statuses: [],
      is_archived: false,
    },
    configuration: {
      search: {
        subbutton: { isVisible: (value = '') => !!value },
        label: 'payment_profiles::filters.dropdown.items.search.label',
        placeholder: 'payment_profiles::filters.dropdown.items.search.label',
        order: 1,
        type: 'input',
      },
      statuses: {
        subbutton: {
          isVisible: (value = [], breakpoints) => value.length > 0 || !!breakpoints.fb,
        },
        icon: (
          <Icon
            name={'avatar1'}
            size={'s'}
            bgColor={'secondary-33'}
            color={'basic-primary-white'}
          />
        ),
        label: 'payment_profiles::filters.dropdown.items.statuses.label',
        position: 'dropdown',
        type: 'checkbox group',
        optionLabelPrefix: 'payment_profiles::statuses.',
        options: ['new', 'pending', 'approved', 'declined'],
      },
      methods: {
        subbutton: {
          isVisible: (value = [], breakpoints) => value.length > 0 || !!breakpoints.fb,
        },
        icon: (
          <Icon
            name={'checkmark2'}
            size={'s'}
            bgColor={'secondary-34'}
            color={'basic-primary-white'}
          />
        ),
        label: 'payment_profiles::filters.dropdown.items.methods.label',
        position: 'dropdown',
        type: 'checkbox group',
        optionLabelPrefix: 'common::payment_methods.',
        options: [
          'epayments',
          'juridical',
          'qiwi',
          'qiwi_wallet',
          'paymaster',
          'paymaster_ru',
          'paypal',
          'stripe',
          'winpay',
          'payoneer',
          'tinkoff',
        ],
      },
      is_archived: {
        subbutton: {
          isVisible: (value = null, breakpoints) => value !== null || !!breakpoints.fb,
        },
        icon: (
          <Icon
            name={'checkmark2'}
            size={'s'}
            bgColor={'secondary-34'}
            color={'basic-primary-white'}
          />
        ),
        label: 'payment_profiles::filters.dropdown.items.is_archive.label',
        position: 'dropdown',
        type: 'radio group',
        optionLabelPrefix: 'payment_profiles::filters.dropdown.items.is_archive.options.',
        options: [true, false],
      },
    },
  }
}
